document.addEventListener('DOMContentLoaded', () => { 
  // Desktop = hover CSS uniquement
  if (window.matchMedia('(hover: hover)').matches) return;

  document.querySelectorAll('.card').forEach(card => {
    const media = card.querySelector('.media--hover-effect');
    const link  = card.querySelector('a[href]');
    if (!media || !link) return;

    // 🔒 On limite volontairement à 3 images MAX
    const imgs = Array.from(media.querySelectorAll('img')).slice(0, 3);

    const hasSecond = imgs.length >= 2;
    const hasThird  = imgs.length >= 3;

    if (!hasSecond) return;

    let step  = 0;
    let timer = null;

    const reset = () => {
      media.classList.remove('mobile-show-second', 'mobile-show-third');
      step = 0;
      timer = null;
    };

    const scheduleReset = () => {
      clearTimeout(timer);
      timer = setTimeout(reset, 2000);
    };

    card.addEventListener('click', (e) => {

      // TAP 1 → image 2
      if (step === 0) {
        e.preventDefault();
        e.stopPropagation();
        media.classList.add('mobile-show-second');
        media.classList.remove('mobile-show-third');
        step = 1;
        scheduleReset();
        return;
      }

      // TAP 2 → image 3
      if (step === 1 && hasThird) {
        e.preventDefault();
        e.stopPropagation();
        media.classList.remove('mobile-show-second');
        media.classList.add('mobile-show-third');
        step = 2;
        scheduleReset();
        return;
      }

// TAP FINAL → navigation sans flash (verrouillage visuel)
e.preventDefault();
e.stopPropagation();

// 🔒 on fige l’état courant (img2 ou img3)
media.classList.add('mobile-lock');

window.location.assign(link.href);

    });
  });
});
